
<section id="premios-col">
    <div class="container">
        <div class="row">
            <div class="col-12 text-center my-auto">
                <h1 >
                    PREMIOS
                    <span class="d-block second">
                        COLABORADOR
                    </span>
                </h1>
         
            </div>
        </div>
    </div>
</section>

<section class="premios-colb-cta">
    <div class="container  mb-5">
        <div class="row">
            <!-- 
                <div class="col-12 text-center my-auto">
                    <a (click)="scrollPage('#premios_cta')" class="cta d-xl-block d-none">
                        <img src="/assets/images/sorteo2023/arrow.png" class="img-fluid" >
                    </a>

                    <a (click)="scrollPage('#premios_cta2')" class="cta d-xl-none d-block">
                        <img src="/assets/images/sorteo2023/arrow.png" class="img-fluid" >
                    </a>
                </div> -->

            <div class="col-12 container-h mt-5">
                <h2>
                    Con Sorteo Anáhuac Todos ganan
                </h2>
                <p>
                    y todos nuestros colaboradores lo saben. Conoce nuestros
                    premios para 
                    <span class="d-block">
                        colaborador donde tenemos un acumulado de más
                        de <strong class="t-bolder"> $3.8 millones de pesos</strong>.
                    </span>
                </p>

               <div class="w-100 text-center mt-5">
                    <img src="/assets/images/sorteo2025/price-opt-col.png" class="img-fluid">
               </div>
            </div>

           

      

        </div>
    </div>
</section>

<!-- <section class="premios-colaborador">
    <div class="container">
        <div class="row ">
            <div class="col-md-12 text-center">
                <div class="controls ">
                    <a type="button" class="control btn-d"
                        data-filter="all"><span>Todos</span></a>
                    <a type="button" class="control btn-d"
                        data-filter=".pp"><span>1º premio</span></a>
                    <a type="button" class="control btn-d"
                        data-filter=".sp"><span>2º premio</span></a>
                    <a type="button" class="control btn-d"
                        data-filter=".tp"><span>3º premio</span></a>
                    <a type="button" class="control btn-d"
                        data-filter=".cp"><span>4º premio</span></a>
                    <a type="button" class="control btn-d"
                        data-filter=".qp"><span>5º premio</span></a>
                    <a type="button" class="control btn-d"
                        data-filter=".otros"><span>Ver más premios</span></a>
                </div>

                <div class="conainter-photos">
                    <div class="row">

                        <div class="col-12">
                            <div class="card-columns-init">

                                <img
                                    src="/assets/images/sorteo2025/premios-colab/premio-col-1.jpg"
                                    class="img-fluid mix pp">

                                <img
                                    src="/assets/images/sorteo2025/premios-colab/premio-col-2.jpg"
                                    class="img-fluid mix sp">

                                <img
                                    src="/assets/images/sorteo2025/premios-colab/premio-col-3.jpg"
                                    class="img-fluid mix tp">

                                <img
                                    src="/assets/images/sorteo2025/premios-colab/premio-col-4.jpg"
                                    class="img-fluid mix cp">

                                <img
                                    src="/assets/images/sorteo2025/premios-colab/premio-col-5.jpg"
                                    class="img-fluid mix qp">

                                <div class="row">
                                    <img
                                        src="/assets/images/sorteo2025/premios-colab/premio-col-6.jpg"
                                        class="img-fluid mix otros col-md-6">
                                    <img
                                        src="/assets/images/sorteo2025/premios-colab/premio-col-7.jpg"
                                        class="img-fluid mix otros col-md-6">
                                    <img
                                        src="/assets/images/sorteo2025/premios-colab/premio-col-8.jpg"
                                        class="img-fluid mix otros col-md-6">
                                    <img
                                        src="/assets/images/sorteo2025/premios-colab/premio-col-9.jpg"
                                        class="img-fluid mix otros col-md-6">
                                    <img
                                        src="/assets/images/sorteo2025/premios-colab/premio-col-10.jpg"
                                        class="img-fluid mix otros col-md-6">
                                    <img
                                        src="/assets/images/sorteo2025/premios-colab/premio-col-11.jpg"
                                        class="img-fluid mix otros col-md-6">
                                </div>

                            </div>
                        </div>

                    </div>

                    <div class="gap"></div>
                    <div class="gap"></div>
                    <div class="gap"></div>
                    <div class="gap"></div>
                </div>
            </div>

        </div>
    </div>
</section> -->


<section class="award-opt" data-aos="fade-up" data-aos-duration="3000" style="background-color: #fff;">
    <div class="container colaborador-p">
        <div class="row">


      
            <div class="col-6 bg-award text-right ">
                <div class="line">
                    <p>1°</p>
                    <p>2°</p>
                    <p>3°</p>
                    <p>4°</p>
                    <p>5°</p>
                    <p>6° al 20°</p>
                    <p>21° al 30°</p>
                    <p>31° al 40°</p>
                    <p>41° al 50°</p>
                    <p>51° al 61°</p>
                    <p>62° al 460°</p>
                </div>
            </div>

            <div class="col-6 bg-award text-left border-0 ">
                <div class="line">
                    <p>$500,000.00</p>
                    <p>$400,000.00</p>
                    <p>$300,000.00</p>
                    <p>$200,000.00</p>
                    <p>$100,000.00</p>
                    <p>$30,000.00</p>
                    <p>$15,000.00</p>
                    <p>$10,000.00</p>
                    <p>$5,000.00</p>
                    <p>$3,000.00</p>
                    <p>$2,000.00</p>
                </div>
            </div>

            <div class="col-12 text-center mt-5 pt-5">
                <img src="/assets/images/sorteo2025/money.png" alt="" class="img-fluid">
            </div>
 
            <div class="col-12 text-center  mt-5 pt-5">
                <a href="{{urlMicrositio}}" target="_blank" class="btn-stack ">compra ya</a>
                <!-- <p>
                    Ó
                </p>
                <a [routerLink]="['/formulario-registro-colaboradores']" class="btn-stack">Vuélvete colaborador</a> -->
            </div>


        </div>
    </div>
</section>
